import { motion } from "framer-motion";

const SHAPES = [
  { size: 340, color: "#1E9BFF", left: "6%", top: "16%", dur: 13, delay: 0, o: 0.16 },
  { size: 260, color: "#0033A0", left: "72%", top: "8%", dur: 16, delay: 1.2, o: 0.1 },
  { size: 200, color: "#7DD3FC", left: "82%", top: "56%", dur: 11, delay: 0.5, o: 0.2 },
  { size: 150, color: "#38BDF8", left: "30%", top: "66%", dur: 15, delay: 2, o: 0.15 },
];

export default function FloatingShapes({ className = "" }) {
  return (
    <div className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`} aria-hidden="true">
      {SHAPES.map((s, i) => (
        <motion.div
          key={i}
          className="absolute rounded-full blur-3xl"
          style={{ width: s.size, height: s.size, background: s.color, left: s.left, top: s.top, opacity: s.o }}
          animate={{ y: [0, -28, 0], x: [0, 18, 0], scale: [1, 1.12, 1] }}
          transition={{ duration: s.dur, delay: s.delay, repeat: Infinity, ease: "easeInOut" }}
        />
      ))}
    </div>
  );
}
